/* @flow */
import variables from '@/styles/export.scss';
import './index.scss';

const types = ['danger', 'warning', 'success', 'info'];
const sizes = ['medium', 'small'];
/**
 * 打开confirmModal
 * @param params 
 * {
 *   type: danger|warning|success|info, 
 *   size: medium|small
 * }
 * @returns {Promise<any>}
 * 
 */
export function openConfirmModal(_this: vue, params: Object): Promise<any> {
  return new Promise((resolve, reject) => {
    const modelSize = params.size || 'small';

    if (typeof params.beforeClose != 'function') {
      throw new Error(`"${params.beforeClose ? params.beforeClose.name : 'fn'}" is not a funcction.`);
    }

    if (!types.includes(params.type)) {
      throw new Error(`type "${params.type}" is unknown.`);
    }

    if (!sizes.includes(modelSize)) {
      throw new Error(`size "${params.size}" is unknown.`);
    }

    const iconColor = variables[`scss-const-color-${params.type}`];
    const iconClass = `el-icon-${params.type === 'danger' ? 'warning' : params.type}`;
    console.log('iconClass', iconClass)
    const customClass = params.size ? params.customClass + ` ${modelSize}` : params.customClass;

    const htmlMessage =
      `<div >
        <div class="az_notify--icon">
         <i class="${iconClass}" style="color:${iconColor};"></i>
        </div>
        <div class="az_notify--content">
          <p>${params.txt}</p>
        </div>
      </div>`;

    const option = {
      title: params.title,
      center: false,
      customClass: `az-confirm ${customClass || ''}`,
      dangerouslyUseHTMLString: true,
      message: htmlMessage,
      showCancelButton: !params.removeCancelBtn,
      showConfirmButton: true,
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      showClose: true,
      beforeClose: (action, instance, done) => {
        params.beforeClose(action, instance, done);
      }
    };

    _this.$msgbox(option).then(action => {
      resolve(action);
    }).catch(err => {
      reject(err);
    });
  });
}